import { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../component/table/tableCustom';
import TableRowCommon from '../../../component/table/TableRowCommon';
import { Box, Dialog, DialogContent, Grid, MenuItem, Typography } from '@mui/material';
import ButtonCustom from '../../../component/button/buttonCustom';
import { icons } from '../../../constants/images'
import InputTextField from '../../../component/input/inputTextField';
import FilterSelect from '../../../component/select/filterSelect';
import EmployeesApi from '../../../api/employees/employees.api';
import DepartmentApi from '../../../api/departments/departments.api';
import RoleApi from '../../../api/role/role.api';
import PositionApi from '../../../api/positions/positions.api';
import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import { useTranslation } from 'react-i18next';
import { Permission } from '../../../constants/permission';
import CheckboxPermission from '../../../component/checkboxPermission/checkboxPermission';
import { useSelector } from 'react-redux';
import InputPasswordField from '../../../component/input/inputPasswordField';


const initStateErrorMessage = {
    positionName: ""
};


export default function ListPosition() {
    const { profile } = useSelector((state: any) => state.profile)
    const permit = profile?.permission || []
    const { t } = useTranslation();
    const [sortBy, setSortBy] = useState<string>('')
    const [sortType, setSortType] = useState<string>('ASC')
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const [input, setInput] = useState<any>({
        positionName: '',
        positionStatus: 'เปิดใช้งาน'
    })
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [rowCount, setRowCount] = useState<number>();
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItem, setTotalItem] = useState<number>();
    const [open, setOpen] = useState<boolean>(false);
    const onRequestSort = (sortBy: string, sortType: string) => {
        setSortType(sortType)
        setSortBy(sortBy)
    }
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        clearErrorMessage();
        setInput({
            positionName:'',
            positionStatus: 'เปิดใช้งาน'
        })
    };
    
    ////////////////////////////////
    const getPosition = async (idPosition: number) => {
        PositionApi.getPosition(idPosition).then((res) => {
            if (res?.data?.success) {
                const data = res.data.result;
                setInput(data);
            }
        })
    }


    const loadData = useCallback(async () => {
        let condition: any = {};
        if (page) condition = { ...condition, page: page };
        if (pageLimit) condition = { ...condition, limit: pageLimit };
        if (sortBy) condition = { ...condition, sortBy: sortBy };
        if (sortType) condition = { ...condition, sortType: sortType };
        PositionApi.getPositions(condition).then((res) => {
            if (res?.data?.success) {
                const { items, meta } = res.data.result;
                setData(items);
                setPage(meta.currentPage)
                setRowCount(meta.totalItems)
                setTotalItem(meta.totalItems)
                setTotalPages(meta.totalPages)
            }
        });
    }, [page, pageLimit, sortBy, sortType]);

    const postData = async () => {
        if (!input.positionName)
            return setErrorMessage({
                ...errorMessage,
                ...{ positionName: t('กรุณากรอกชื่อ') },
            });
     
        const body = {
            ...input,
        }
        if (input?.idPosition) {
            setLoading(true)
            await PositionApi.patchPosition(input?.idPosition, body).then((res) => {
                if (res?.data?.success) {
                    setLoading(false)
                    handleClose()
                    swalSuccess(t('แก้ไขตำแหน่งสำเร็จ'))
                    loadData()
                } else {
                    setLoading(false)
                    swalError(res.response.data.description || res.response.data.message);
                }

            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        } else {
            setLoading(true)

            await PositionApi.postPosition(body).then((res) => {
                if (res?.data?.success) {
                    setLoading(false)
                    handleClose()
                    swalSuccess(t('สร้างตำแหน่งสำเร็จ'))
                    loadData()
                } else {
                    setLoading(false)
                    swalError(res.response.data.description || res.response.data.message);

                }
            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        }
    }
    const changeStatus = async (value: string, objData: any) => {
        await PositionApi.patchPosition(objData?.idPosition, { ...objData, positionStatus: value }).then((res) => {
            if (res?.data?.success) {
                swalSuccess(t('EMPLOYEES_CREATE.SWAL.EDIT_STATUS_SUCCESS'))
                loadData()
            } else {
                swalError(res.response.data.description || res.response.data.message);

            }

        }).catch((error: any) => {
            swalError(error.response.data.description || error.response.data.message);
        })
    }


    useEffect(() => {
        loadData()
    }, [loadData])

    const headCells = [
        {
            id: "positionName",
            label: t('ชื่อตำแหน่ง'),
            align: "left",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "positionStatus",
            label: t('EMPLOYEES.HEADCELL.STATUS'),
            align: "center",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            colSpan: 1,
        },
    ];


    const renderData = (objData: any, index: any) => {
        const { positionName, positionStatus, idPosition } = objData;
        index = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: index,
            id: idPosition,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: positionName },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <>
                            <FilterSelect
                                disabled={!permit.find((x: any) => x?.code === 'Position.Read')?.permit}
                                labelId='' selectId='' style={{
                                    '& .MuiSelect-select': {
                                        backgroundColor: positionStatus === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                        color: positionStatus === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                        margin: '0px 30px 0px 6px',
                                        padding: '5px 0px',
                                    }
                                }} options={[{ value: 'เปิดใช้งาน', name: t('EMPLOYEES.STATUS.ACTIVE') }, { value: 'ไม่ใช้งาน', name: t('EMPLOYEES.STATUS.UNACTIVE') }].map((x, i) => {
                                    return (
                                        <MenuItem key={i}
                                            value={x.value}
                                            sx={{
                                                backgroundColor: x.value === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                                color: x.value === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                            }}
                                        >
                                            ● {x.name}
                                        </MenuItem>
                                    )
                                })} value={positionStatus} onchange={(e: any) => { changeStatus(e.target.value, objData) }} />
                        </>
                    )
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <>
                            {permit.find((x: any) => x?.code === 'Position.Read')?.permit && <icons.dotMenu onClick={() => {
                                handleClickOpen()
                                getPosition(idPosition)
                            }} style={{ cursor: "pointer" }} />}
                        </>
                    )
                }

            ],

        }


        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };

    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>{t('จัดการตำแหน่ง')}</TitleText>
                {permit.find((x: any) => x?.code === 'Position.Add')?.permit && <ButtonCustom variant={'outlined'}
                    startIcon={<icons.circleButton />}
                    textButton={t('EMPLOYEES.BUTTON.CREATE')}
                    onClick={() => handleClickOpen()} />}
            </LayoutTitle>
            <TableCustom
                headCells={headCells}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={sortType}
                sortBy={sortBy}
                rowCount={rowCount}
                rowsData={data?.map((d: any, index: any) => {
                    return renderData(d, index);
                })}
                onSort={onRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
                totalPages={totalPages}
                totalItem={totalItem}
            />
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                fullWidth
                maxWidth='md'
            >
                <DialogContent sx={{ padding: '32px', gap: '32px', display: 'flex', flexDirection: "column" }}>
                    <div style={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                        <TitleText>{t('จัดการตำแหน่ง')}</TitleText>
                    </div>
                    <Grid container spacing={1}>

                        <Grid item xs={12}><InputTextField heading={t('ชื่อตำแหน่ง')} value={input.positionName} onchange={(event: any) => {
                            setInput({ ...input, positionName: event.target.value });
                            clearErrorMessage();
                        }}
                            helperText={
                                errorMessage.positionName || ''
                            } /></Grid>
                    </Grid>
                    <ButtonCustom textButton={t('EMPLOYEES_CREATE.BUTTON.SUBMMIT')} disabled={loading} style={{ margin: "auto" }} onClick={() => postData()} />
                </DialogContent>

            </Dialog>
        </LayoutView >
    )
}
